<!-- 首页 -->
<template>
  <div class="home-wrapper">
    <div class="padding-0-20">
      <GreetingArea />
    </div>
    <div @click="onClickHomeImage">
      <HomeImage />
    </div>
    <div class="padding-0-20 margin-bottom-21">
      <TaskProgress :progress="progress" progress-text="治疗进度" />
    </div>
    <div class="padding-0-20">
      <div class="margin-bottom-7">
        <Subtitle sub-title="工具栏" />
      </div>
      <ToolCard :config="tools" @click="onClick" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import HomeImage from "./HomeImage";
import { GreetingArea, Subtitle, ToolCard, TaskProgress } from "@/components";
import config from "./config";
import { treatmentProgress } from "@/api/treatmentCalendar";
export default {
  name: "Home",
  components: {
    GreetingArea,
    HomeImage,
    TaskProgress,
    Subtitle,
    ToolCard,
  },
  data() {
    return {
      tools: config.tools,
      progress: 0,
    };
  },
  created() {},
  activated() {
    this.initData();
  },
  methods: {
    ...mapActions(["getCurrentIdFn"]),
    async initData() {
      try {
        this.progress = 0;
        const resId = await this.getCurrentIdFn();
        if (resId && resId !== -1) {
          const resData = await treatmentProgress(resId);
          this.progress = resData;
        }
      } catch (error) {
        console.log(error);
      }
    },
    onClickHomeImage() {},
    onClick(_, item) {
      this.$router.push({
        path: item.pagePath,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.padding-0-20 {
  padding: 0 20px;
}
.margin-bottom-7 {
  margin-bottom: 7px;
}
.margin-bottom-21 {
  margin-bottom: 21px;
}
</style>
